import { useCallback, useState } from 'react';

export function usePackArchitectureTableCellHover() {
    const [hoveredRowKey, setHoveredRowKey] = useState<string | null>(null);
    const [hoveredColumnKey, setHoveredColumnKey] = useState<string | null>(null);

    const handleCellHover = useCallback((rowKey: string, columnKey: string | null) => {
        setHoveredRowKey(rowKey);
        setHoveredColumnKey(columnKey);
    }, []);

    const handleColumnHeaderHover = useCallback((columnKey: string) => {
        setHoveredRowKey(null);
        setHoveredColumnKey(columnKey);
    }, []);

    const clearCellHover = useCallback(() => {
        setHoveredRowKey(null);
        setHoveredColumnKey(null);
    }, []);

    return {
        hoveredRowKey,
        hoveredColumnKey,
        handleCellHover,
        handleColumnHeaderHover,
        clearCellHover,
    };
}
